import { render, staticRenderFns } from "./articleDetails.vue?vue&type=template&id=7ac8c308&scoped=true&"
import script from "./articleDetails.vue?vue&type=script&lang=js&"
export * from "./articleDetails.vue?vue&type=script&lang=js&"
import style0 from "./articleDetails.vue?vue&type=style&index=0&id=7ac8c308&prod&scoped=true&lang=scss&"
import style1 from "./articleDetails.vue?vue&type=style&index=1&id=7ac8c308&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8c308",
  null
  
)

export default component.exports